export const PAYMENT_TERMS_PRESETS = [
  { value: "net_7", label: "Net 7" },
  { value: "net_30", label: "Net 30" },
  { value: "net_60", label: "Net 60" },
  { value: "cod", label: "COD" },
  { value: "other", label: "Other" },
] as const;

export type PaymentTermsPreset = (typeof PAYMENT_TERMS_PRESETS)[number]["value"];

export function formatPaymentTerms(
  preset?: string | null,
  custom?: string | null,
): string {
  if (!preset) return "—";
  if (preset === "other") return custom?.trim() || "—";
  const match = PAYMENT_TERMS_PRESETS.find((p) => p.value === preset);
  return match?.label ?? "—";
}
